import React from 'react';

const LabelledEditablePicker = ({ label, type, value, name, onChange, onBlur, children }) => {

  const onPickerChange = (e) => {
    onChange({
      ...e,
      value: e.target.value,
      name: e.target.name,
      type: e.target.type,
    });
  };

  const onPickerBlur = (e) => {
    onBlur({
      ...e,
      value: e.target.value,
      name: e.target.name,
      type: e.target.type,
    });
  };

  return (
    <div className="labelled-editable-picker">
      <span className="label">{label}</span>
      <input
        type={type ? type : 'text'}
        value={value?.toString() ?? ''}
        name={name}
        onChange={onPickerChange}
        onBlur={onPickerBlur}
        placeholder={label}
        list={`${name}-list`}
      />
      <datalist id={`${name}-list`}>
        {children}
      </datalist>
    </div>
  );
};

export default LabelledEditablePicker;
